import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';

const clients = 'management/clients';
const project = 'project';

const apiRoutes = {
	general_list: project + '/questionnaires/general-list',
	questionnaires: project + '/questionnaires',
	clone_questionnaire: project + '/clone/questionnaire',
	questionnaire: project + '/questionnaire',
	questionnaires_baselines: project + '/questionnaires/baselines',
	questionnaire_templates: clients + '/questionnaire/templates',
	questionnaire_baselines: clients + '/questionnaire/baselines',
	questionnaire_baseline: clients + '/questionnaire/baseline',
}

@Injectable({ providedIn: 'root' })
export class QuestionnaireService {

	private refreshQuestionnaireList = new Subject<void>();

	constructor(private http: HttpClient) { }

	refreshList() {
    this.refreshQuestionnaireList.next();
  }

	getRefreshObservable() {
    return this.refreshQuestionnaireList.asObservable();
  }

	getGeneralList(code: any) {
		return this.http.get<any>(environment.api + apiRoutes.general_list, { params: { code: code } });
	}

	getProjectQuestionnaires(project_id: number, params: any) {
		return this.http.get<any>(environment.api + apiRoutes.questionnaires + '/' + project_id, { params: params });
	}

	getClientQuestionnaireTemplates(params: any) {
		return this.http.get<any>(environment.api + apiRoutes.questionnaire_templates, { params: params });
	}

	getClientQuestionnaireBaselines(params: any) {
		return this.http.get<any>(environment.api + apiRoutes.questionnaire_baselines, { params: params });
	}

	getClientQuestionnaireBaseline(baseline_id: number) {
		return this.http.get<any>(environment.api + apiRoutes.questionnaire_baseline + '/' + baseline_id);
	}

	createQuestionnaireBaseline(data: any) {
		return this.http.post<any>(environment.api + apiRoutes.questionnaire_baseline, data);
	}

	updateQuestionnaireBaseline(data: any, baseline_id: number) {
		return this.http.patch<any>(environment.api + apiRoutes.questionnaire_baseline + '/' + baseline_id, data);
	}

	deleteQuestionnaireBaseline(baseline_id: number) {
		return this.http.delete<any>(environment.api + apiRoutes.questionnaire_baseline + '/' + baseline_id);
	}

	getQuestionnaireBaselines(project_id: number, lang: any) {
		return this.http.get<any>(environment.api + apiRoutes.questionnaires_baselines + '/' + project_id, { params: { lang: lang } });
	}

	getQuestionnaireGeneralList(project_id: number, code: any) {
		return this.http.get<any>(environment.api + apiRoutes.general_list, { params: { code: code } });
	}

	getProjectQuestionnaire(project_id: number, questionnaire_id: number) {
		return this.http.get<any>(environment.api + apiRoutes.questionnaire + '/' + project_id + '/' + questionnaire_id);
	}

	createProjectQuestionnaire(project_id: number, data: any) {
		return this.http.post<any>(environment.api + apiRoutes.questionnaire + '/' + project_id, data);
	}

	updateProjectQuestionnaire(project_id: number, questionnaire_id: number, data: any) {
		return this.http.patch<any>(environment.api + apiRoutes.questionnaire + '/' + project_id + '/' + questionnaire_id, data);
	}

	deleteProjectQuestionnaire(project_id: number, questionnaire_id: number) {
		return this.http.delete<any>(environment.api + apiRoutes.questionnaire + '/' + project_id + '/' + questionnaire_id);
	}

	cloneQuestionnaire(data: any) {
		return this.http.post<any>(environment.api + apiRoutes.clone_questionnaire, data);
	}

}